import {
  take,
  put,
  call,
  all,
  takeLatest,
  takeEvery,
} from 'redux-saga/effects';
import { mrfActions as actions, notificationActions } from '../actions';
import { mrfService } from '../services';

/* Create Update Mrf Sagas */
function* handleCreateUpdateMrfRequest() {
  const action = yield take(actions.createUpdateMrfRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(mrfService.createUpdateMrf, dataParams);
    if (res.isError) {
      yield put(actions.createUpdateMrfError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.createUpdateMrfSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.createUpdateMrfError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/*  Create Get Interviewer List Sagas */
function* handleGetInterviewerListRequest() {
  const action = yield take(actions.getInterviewerListRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(mrfService.getInterviewerList, dataParams);
    if (res.isError) {
      yield put(actions.getInterviewerListError(res));
    } else {
      yield put(actions.getInterviewerListSuccess(res));
    }
  } catch (error) {
    yield put(actions.getInterviewerListError());
  }
}

/*Get Mrf Data By Id Sagas */
function* handleGetMrfDataByIdRequest() {
  const action = yield take(actions.getMrfDataByIdRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(mrfService.getMrfDataById, dataParams);
    if (res.isError) {
      yield put(actions.getMrfDataByIdError(res));
    } else {
      yield put(actions.getMrfDataByIdSuccess(res));
    }
  } catch (error) {
    yield put(actions.getMrfDataByIdError());
  }
}

/* Submit Draft Mrf Sagas */
function* handleSubmitDraftMrfRequest() {
  const action = yield take(actions.submitDraftMrfRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(mrfService.submitDraftMrf, dataParams);
    if (res.isError) {
      yield put(actions.submitDraftMrfError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.submitDraftMrfSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.submitDraftMrfError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* Get All User Mrf Sagas*/
function* handleGetAllUserMrfRequest() {
  const action = yield take(actions.getAllUserMrfRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(mrfService.getAllUserMrf, dataParams);
    if (res.isError) {
      yield put(actions.getallUserMrfError(res));
    } else {
      yield put(actions.getAllUserMrfSuccess(res));
    }
  } catch (error) {
    yield put(actions.getAllUserMrfError());
  }
}

/* Get Mrf Dashboard And Hierarchy Sagas */
function* handleGetMrfDashboardAndHierarchyRequest() {
  const action = yield take(actions.getMrfDashboardAndHierarchyRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(mrfService.getMrfDashboardAndHierarchy, dataParams);
    if (res.isError) {
      yield put(actions.getMrfDashboardAndHierarchyError(res));
    } else {
      yield put(actions.getMrfDashboardAndHierarchySuccess(res));
    }
  } catch (error) {
    yield put(actions.getMrfDashboardAndHierarchyError());
  }
}

/* Get Mrf For Approval Data Sagas */
function* handleGetMrfForApprovalDataRequest() {
  const action = yield take(actions.getMrfForApprovalDataRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(mrfService.getMrfForApprovalData, dataParams);
    if (res.isError) {
      yield put(actions.getMrfForApprovalDataError(res));
    } else {
      yield put(actions.getMrfForApprovalDataSuccess(res));
    }
  } catch (error) {
    yield put(actions.getMrfForApprovalDataError());
  }
}

/* Approve Reject Mrf */
function* handleApproveRejectMrfRequest() {
  const action = yield take(actions.approveRejectMrfRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(mrfService.approveRejectMrfData, dataParams);
    if (res.isError) {
      yield put(actions.approveRejectMrfError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.approveRejectMrfSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.approveRejectMrfError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* -----------Watchers------------- */
function* handleCreateUpdateMrfWatcher() {
  yield takeEvery(
    actions.createUpdateMrfRequest,
    handleCreateUpdateMrfRequest,
  );
}

function* handleGetInterviewerListWatcher() {
  yield takeEvery(
    actions.getInterviewerListRequest,
    handleGetInterviewerListRequest,
  );
}

function* handleGetMrfDataByIdWatcher() {
  yield takeEvery(
    actions.getMrfDataByIdRequest,
    handleGetMrfDataByIdRequest,
  );
}

function* handleSubmitDraftMrfWatcher() {
  yield takeEvery(
    actions.submitDraftMrfRequest,
    handleSubmitDraftMrfRequest,
  );
}

function* handleGetAllUserMrfWatcher() {
  yield takeEvery(
    actions.getAllUserMrfRequest,
    handleGetAllUserMrfRequest,
  );
}


function* handleGetMrfDashboardAndHierarchyWatcher() {
  yield takeEvery(
    actions.getMrfDashboardAndHierarchyRequest,
    handleGetMrfDashboardAndHierarchyRequest,
  );
}

function* handleGetMrfForApprovalDataWatcher() {
  yield takeEvery(
    actions.getMrfForApprovalDataRequest,
    handleGetMrfForApprovalDataRequest,
  );
}

function* handleApproveRejectMrfWatcher() {
  yield takeEvery(
    actions.approveRejectMrfRequest,
    handleApproveRejectMrfRequest,
  );
}





function* rootMrfSaga() {
  yield all([
    handleCreateUpdateMrfRequest(),
    handleCreateUpdateMrfWatcher(),

    handleGetInterviewerListRequest(),
    handleGetInterviewerListWatcher(),

    handleGetMrfDataByIdRequest(),
    handleGetMrfDataByIdWatcher(),

    handleSubmitDraftMrfRequest(),
    handleSubmitDraftMrfWatcher(),

    handleGetAllUserMrfRequest(),
    handleGetAllUserMrfWatcher(),

    handleGetMrfDashboardAndHierarchyRequest(),
    handleGetMrfDashboardAndHierarchyWatcher(),

    handleGetMrfForApprovalDataRequest(),
    handleGetMrfForApprovalDataWatcher(),

    
    handleApproveRejectMrfRequest(),
    handleApproveRejectMrfWatcher(),



  ]);
}

export default rootMrfSaga;
